<template>
  <v-container>
    <h1>Meine Spiele</h1>

    <div v-if="isLoading" class="text-xs-center">
      <v-progress-circular :size="70" :width="7" color="blue-grey lighten-1" indeterminate></v-progress-circular>
    </div>

    <div v-if="!isLoading">
			<v-alert
				v-model="showError"
				type="error"
				transition="scale-transition"
				origin="center center"
			>{{errorMessage}}</v-alert> <!-- 				dismissible -->

      <div v-if="!showError && games.length === 0">
				<p>Du hast noch kein Spiel freigeschaltet.</p>
			</div>

      <div v-if="!showError && games.length > 0">
				<p>Hier sind alle von Dir freigeschalteten Spiele aufgeführt.</p>
        <v-layout>
          <v-flex>
            <v-card v-for="game in games" v-bind:key="game.id" style="margin-bottom: 16px; max-width: 800px">
              <v-img :src="`https://sonnt.ag/steamgiveaway${game.img}`"></v-img>
              <!-- src="https://cdn.vuetifyjs.com/images/cards/desert.jpg" aspect-ratio="2.75" -->
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">{{game.title}}</h3>
                  <div>
                    <!-- <span v-for="genre in game.genres" v-bind:key="genre" style="margin-right: 8px">{{genre}}</span> -->
										<v-breadcrumbs :items="game.genres"></v-breadcrumbs>
										<p>Steam Key: {{game.key}}</p>
										<p v-if="game.keynote">Anmerkungen: {{game.keynote}}</p>
                  </div>
                </div>
              </v-card-title>

              <v-card-actions>
								<v-layout row wrap>
									<v-btn flat color="info" v-on:click="openSteampage(game)">Öffne Steampage</v-btn>
									<v-btn flat color="success" v-on:click="redeemOnSteam(game)">Auf Steam Einlösen</v-btn>
								</v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </div>

    <v-snackbar
      v-model="showSnackbar"
      bottom
      v-bind:timeout="6000"
			v-bind:color="snackbarColor"
    >
      {{ snackbarText }}
      <v-btn
        flat
        @click="showSnackbar = false"
      >
        Schließen
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";

import { eventBus } from '../main'; 

export default {
  data: () => ({
    username: null,

    games: [],

    isLoading: false,
    showError: false,
		errorMessage: "",

		showSnackbar: false,
		snackbarText: '',
		snackbarColor: '',
  }),

  methods: {
    loadGames() {
      this.isLoading = true;
      this.showError = false;
			this.errorMessage = "";

      const url = process.env.VUE_APP_APIBASEURL + "/mygames";
      console.log("fetching /mygames:", url);
      axios
        .get(url, { headers: { user: this.username } })
        .finally(() => {
          this.isLoading = false;
        })
        .then(response => {
          const games = response.data;
          games.forEach(game => {
            game.genres = JSON.parse(game.genres).map(genre => {
							return {
								text: genre,
								disabled: true
							}
						});
          });
          this.games = response.data;
        })
        .catch(error => {
					this.showError = true;

          this.errorMessage = error.message;

          if (error.response && error.response.data && error.response.data.error) {
            this.errorMessage = error.response.data.error;
					}
					
					this.errorMessage = 'Beim Abruf der Daten trat ein Fehler auf, bitte versuche es später noch einmal. Der Fehler war: ' + this.errorMessage;

          return;
        });
    },

		loadLastRedemption() {
      const url = process.env.VUE_APP_APIBASEURL + "/lastredemption";
      console.log("fetching /lastredemption:", url);
      axios
        .get(url, { headers: { user: this.username } })
        .then(response => {
					let lastRedemption = null;
					
					console.log(response.data);
					
					if (response.data && response.data.lastredemption) {
						lastRedemption = moment(response.data.lastredemption);
						console.log('last redemption is:', lastRedemption);
					} else {
						console.log('last redemption is not set (we provide null)');
					};

					eventBus.setLastRedemption(lastRedemption);
				})
        .catch(error => {
					console.log('fetch /lastredemption ERROR:', error);
          return;
				});
		},

		openSteampage(game) {
      const win = window.open(game.url, "_blank");
      win.focus();
    },

		addToWishlist(game) {
			game.isLoadingWishlist = true;

			const options = {
					method: 'POST',
					url: process.env.VUE_APP_APIBASEURL + '/addtowishlist?gameid=' + game.id,
					data: null,
					headers: {
						user: this.username
					},
					json: false
			};

      console.log("adding to wishlist:", options);
      axios(options)
        //.post(url, { headers: { user: this.username } })
        .finally(() => {
          game.isLoadingWishlist = false;
        })
        .then(response => {
					console.log('RESPONSE!');
					this.snackbarColor = '';
					this.showSnackbar = true;
					this.snackbarText = 'Spiel wurde zur Wunschliste hinzugefügt.';
					game.id_wishlist = -1;
        })
        .catch(error => {
					console.log('ERROR!');
					this.snackbarColor = 'error';
					this.showSnackbar = true;

          this.snackbarText = error.message;

          if (error.response && error.response.data && error.response.data.error) {
            this.snackbarText = error.response.data.error;
					}
					
					this.snackbarText = this.snackbarText;

          return;
        });
		},

		redeemOnSteam(game) {
      const win = window.open('https://store.steampowered.com/account/registerkey?key=' + game.key, "_blank");
      win.focus();
		},
},

  // ### Life-Cycle Hooks ###
  created() {
    console.log("AllGames.vue CREATED!");

    this.username = localStorage.getItem("u");

    if (!this.username) {
      console.log("username not found, redirecting to /login");
      this.$router.push("/login");
      return;
    }

		this.loadGames();
		this.loadLastRedemption();
  }
};
</script>

<style>
</style>
